import React from 'react'
import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineEyeIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M21.92 11.6C19.9 6.91 16.1 4 12 4s-7.9 2.91-9.92 7.6a.9999.9999 0 0 0 0 .8C4.1 17.09 7.9 20 12 20s7.9-2.91 9.92-7.6a.9994.9994 0 0 0 0-.8ZM12 18c-3.17 0-6.17-2.29-7.9-6C5.83 8.29 8.83 6 12 6s6.17 2.29 7.9 6c-1.73 3.71-4.73 6-7.9 6Zm0-10a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm0 6a2 2 0 0 1-1.9616-2.3902 2.0004 2.0004 0 0 1 1.5714-1.5714A2 2 0 1 1 12 14Z"/>
  </SvgIcon>
}

export default LineEyeIcon
